export default __webpack_public_path__ + "static/media/play-again.6c035bbc.jpg";